import { createFileRoute } from '@tanstack/react-router';
import NewUserPage from 'src/Administration/NewUserPage/NewUserPage';

export const Route = createFileRoute('/systemadmin/_layout/users/new')({
  component: NewUserPage,
});
